import axios from 'axios';
import { handleReject, handleRequest } from './helpers';
import { CreateAPIConnectionCbProps } from './interfaces';
import { notify } from 'front-commons/ds';

export const createAPIConnection = (serviceURL: string, callbacks?: CreateAPIConnectionCbProps) => {
	const api = axios.create({
		baseURL: `${import.meta.env.VITE_API_BASE}${serviceURL}`,
	});

	api.interceptors.request.use(
		(config) => handleRequest(config, callbacks?.onRequest),
		(error) => {
			return Promise.reject(error);
		},
	);

	window.rateLimit = {}
	const maxRetries = 3;
	const retryDebounce = 500;

	api.interceptors.response.use(
		(response) => {
			const identifier = `${response.config.baseURL}${response.config.url}`;

			if (typeof window.rateLimit[identifier] === 'number') {
				window.rateLimit[identifier] = 'DONE';
			}

			return response
		},
		(response) => {
			if (response.status === 429 && !response.response.headers['x-login-retry-after']) {
				const identifier = `${response.config.baseURL}${response.config.url}`;

				if (!window.rateLimit[identifier] || typeof window.rateLimit[identifier] === 'string') {
					window.rateLimit[identifier] = 0;
				}

				if (window.rateLimit[identifier] < maxRetries) {
					window.rateLimit[identifier] += 1

					return new Promise((resolve) => {
						setTimeout(() => {
							resolve(api(response.config))
						}, retryDebounce)
					})
				}

				window.rateLimit[identifier] = 'FAILED';

				notify.negative({ description: 'Muitas requisições simultâneas. Tente novamente mais tarde.' });
				Promise.reject(response)
			}

			callbacks?.onReject?.(response);
			handleReject(response);
		},
	);

	return api;
};
